import { ChangeEvent, useState, useEffect, useCallback } from 'react';
import styles from '@/interface/ui/search/index.module.scss';
import KeywordSearch from '@/interface/ui/search/_component/KeywordSearch';
import Layout from '@/interface/ui/_shared/layout/index';
import SearchResult from '@/interface/ui/search/_component/SearchResult';
import { useResponsive } from '@/hooks/useResponsive';
import { useInView } from 'react-intersection-observer';
import Spinner from '../_shared/util/spinner';
import { useItemSearch } from '@/hooks/useItemSearch';
import Head from 'next/head';
import colors from '@/constants/colors';

interface Props {
  mode: 'pink' | 'default';
}

const Page = ({ mode }): React.ReactElement<Props> => {
  const { isDesktop } = useResponsive();
  const [isLoading, setLoading] = useState(false);

  const isModePink = mode === 'pink';
  const {
    searchText,
    setSearchText,
    execSearch,
    reset,
    paging,
    searchingText,
    hasNoMoreData,
    scrollId,
    items,
  } = useItemSearch({
    isModePink,
  });

  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (isDesktop && searchingText !== undefined) {
      setSearchText(searchingText);
    }
  }, [isDesktop, searchingText, setSearchText]);

  const loadMore = useCallback(async () => {
    try {
      if (!scrollId || hasNoMoreData || !inView) return;
      setLoading(true);
      await paging(scrollId);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [scrollId, hasNoMoreData, inView, paging]);

  useEffect(() => {
    if (inView) {
      void loadMore();
    }
  }, [inView, loadMore]);

  const onFocusSearchTextInput = () => {
    if (searchText.length) {
      // dispatch(searchItemsResetSucceeded());
    }
  };

  const onBlurSearchTextInput = async (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const nextSearchText = event.target.value;
    await execSearch(nextSearchText);
  };

  return (
    <>
      <Head>
        <title>{'atmos LISTs | 検索'}</title>
        <meta property="og:title" content={'atmos LISTs | 検索'} key="title" />
      </Head>
      <Layout style={{ backgroundColor: colors.background }} mode={mode}>
        <div className={styles.container}>
          {!isDesktop && (
            <div className={styles.keywordSearchContainer}>
              <KeywordSearch
                onBlur={onBlurSearchTextInput}
                onFocus={onFocusSearchTextInput}
                clearText={reset}
                searchText={searchText}
                searchingText={searchingText}
                setTextValue={setSearchText}
              />
            </div>
          )}
          <SearchResult
            searchedItems={items}
            searchText={searchingText || ''}
            isLoading={isLoading}
          />
          <div ref={ref}>
            {isLoading && <Spinner />}
            <h2 className={styles.dumbFooter} />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Page;
